<template>
    <v-navigation-drawer
        permanent
        app
        dark
        floating
        persistent
        width="220"
    >
        <v-list-item>
            <v-list-item-title class="title">
                ROUNDNAVI-WEB
            </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense nav>
            <v-list-item
                v-for="item in items"
                :key="item.title"
                :to="item.to"
                :disabled="item.isPush"
            >
                <template
                    v-if="item.childhas === false"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    <v-badge
                        :content="messageCount"
                        :value="messageCount"
                        color="red"
                        overlap
                        v-if="item.badge && chatboxSetting"
                    ></v-badge>
                </template>
                <template
                    v-if="item.childhas === true"
                >
                    <v-list-group
                        no-action
                        color="white"
                    >
                        <template v-slot:activator>
                            <v-list-item
                                class="pl-12"
                            >
                                <v-list-item-content>
                                    <v-list-item-title
                                        class="text-white"
                                    >{{ item.title }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>

                        <v-list-item
                            v-for="(child, i) in item.children"
                            :key="i"
                            link
                            :to="child.to"
                            :disabled="child.isPush"
                            style="padding-left: 70px; "
                        >
                            <v-list-item-title v-text="child.title"/>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list class="mt-5">
            <v-row justify="center">
                <v-btn width="80%" color="blue" @click="logout()">ログアウト</v-btn>
            </v-row>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { GET_OPERATION_ACCESSES_LIST } from '../../constants/operation_accesses';
import { ADMIN_LOGOUT } from '../../constants/side_menu';

// 会員一覧画面、マスタ管理、管理ユーザ
const VUE_ID = 'SCR0003,SCR0009,SCR0010,SCR0011,SCR0012,SCR0013,SCR0014,SCR0015,SCR0022,SCR0024,SCR0029,SCR0030,SCR0031,SCR0106,SCR0107,SCR0108,SCR0109';

export default {
    components: {
    },
    data: () => ({
        baseItems: [
            { vueid: 'SCR0003', title: '会員一覧', icon: '', to: '/', isPush: true, childhas: false, badge: false },
            { vueid: 'SCR0106', title: 'ChatBox', icon: '', to: '/chatBox', isPush: true, childhas: false, badge: true },
            {
                vueid: '',
                title: '予約状況照会',
                icon: '',
                isPush: false,
                childhas: true,
                children: [
                    { vueid: 'SCR0013', title: '日付指定', icon: '', to: '/reserveListByDay', isPush: false, grandchildhas: false },
                    { vueid: 'SCR0014', title: '月指定', icon: '', to: '/reserveListByMonth', isPush: false, grandchildhas: false },
                    { vueid: 'SCR0015', title: '予約一覧', icon: '', to: '/reserveListByConditions', isPush: false, grandchildhas: false },
                    { vueid: 'SCR0022', title: 'リクエスト予約', icon: '', to: '/reserveRequest', isPush: false, grandchildhas: false }
                ],
                badge: false
            },
            {
                vueid: '',
                title: 'プラン　　　',
                icon: '',
                isPush: false,
                childhas: true,
                children: [
                    { vueid: 'SCR0024', title: '一覧', icon: '', to: '/planList', isPush: false },
                    { vueid: 'SCR0029', title: 'プレー時間管理', icon: '', to: '/startTime', isPush: false },
                    { vueid: 'SCR0030', title: 'プラン用マスタ管理', icon: '', to: '/planMaster', isPush: false }
                ],
                badge: false
            },
            {
                vueid: '',
                title: '配信管理　　',
                icon: '',
                isPush: false,
                childhas: true,
                children: [
                    { vueid: 'SCR0107', title: '当日連絡事項設定', icon: '', to: '/deliverySetting', isPush: false },
                    { vueid: 'SCR0109', title: '随時連絡事項設定', icon: '', to: '/deliveryMessage', isPush: false },
                    { vueid: 'SCR0108', title: '配信実績照会', icon: '', to: '/deliveryResults', isPush: false }
                ]
            },
            { vueid: 'SCR0009', title: '管理ユーザー', icon: '', to: '/admin', isPush: true, childhas: false, badge: false },
            { vueid: 'SCR0010', title: 'マスタ管理', icon: '', to: '/master', isPush: true, childhas: false, badge: false },
            { vueid: 'SCR0031', title: 'システム設定', icon: '', to: '/system', isPush: true, childhas: false, badge: false },
            { vueid: 'SCR0011', title: 'ポイント一括登録', icon: '', to: '/pointBulkRegistration', isPush: true, childhas: false, badge: false },
            { vueid: 'SCR0012', title: 'パスワード変更', icon: '', to: '/loginAdmin', isPush: true, childhas: false, badge: false }
        ],
        items: [],
        childObj: {
            'd-none': true
        },
        messageCount: 0,
        chatboxSetting: false,
        pointSetting: false
    }),
    mounted () {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'auth/setMessageCount') {
                this.messageCount = this.$store.state.auth.messageCount;
            }
        });
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         *---------------------------------------------- */
        initialize: async function () {
            this.getAuthority();
        },
        /** --------------------------------------------
         * 操作権限を取得
         * -------------------------------------------- */
        async getAuthority () {
            try {
                // トークンからログインユーザーのIDを取得する
                let userId = await this.$apollo.mutate({
                    mutation: GET_LOGIN_ADMIN
                }).then(res => {
                    return res.data.getLoginAdmin.user_id;
                });

                // 操作権限を取得
                this.$apollo
                    .query({
                        query: GET_OPERATION_ACCESSES_LIST,
                        variables: {
                            golf_group_code: process.env.VUE_APP_GROUP_CODE,
                            user_id: userId,
                            vue_id: VUE_ID,
                            element_id: '000'
                        }
                    })
                    .then(res => {
                        const opeList = res.data.GetOperationAccessList.OperationAccessList;
                        this.chatboxSetting = res.data.GetOperationAccessList.ChatboxSetting;
                        this.pointSetting = res.data.GetOperationAccessList.PointSetting;
                        this.displayControl(opeList);
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
         * 表示制御処理
         * -------------------------------------------- */
        displayControl (opeList) {
            this.items = [];
            for (let i = 0; i < this.baseItems.length; i++) {
                var itemParent = {};
                var itemChildren = [];
                for (let j = 0; j < opeList.length; j++) {
                    if (this.baseItems[i].children) {
                        this.baseItems[i].children.forEach(el => {
                            if (el.vueid === opeList[j].vue_id) {
                                if (opeList[j].element_control === 1) {
                                    el.isPush = false;
                                } else {
                                    el.isPush = true;
                                }
                                if (opeList[j].display_control === 1) {
                                    itemChildren.push(el);
                                }
                            }
                        });
                    }
                    if (this.baseItems[i].vueid === opeList[j].vue_id) {
                        // 活性の場合
                        if (opeList[j].element_control === 1) {
                            this.baseItems[i].isPush = false;
                        } else {
                            this.baseItems[i].isPush = true;
                        }

                        // システム設定で機能が停止されている場合
                        if (this.baseItems[i].vueid === 'SCR0106' && !this.chatboxSetting) {
                            this.baseItems[i].isPush = true;
                        } else if (this.baseItems[i].vueid === 'SCR0011' && !this.pointSetting) {
                            this.baseItems[i].isPush = true;
                        }

                        // 活性の場合
                        if (opeList[j].display_control === 1) {
                            itemParent = this.baseItems[i];
                        }
                        break;
                    }
                }
                if (itemChildren.length !== 0) {
                    itemParent = this.baseItems[i];
                    itemParent.children = itemChildren;
                }
                if (Object.keys(itemParent).length) {
                    this.items.push(itemParent);
                }
            }
        },
        /** --------------------------------------------
         * ログアウトボタン処理
         * -------------------------------------------- */
        logout () {
            this.$apollo.mutate({
                mutation: ADMIN_LOGOUT,
                variables: {}
            }).then(res => {
                localStorage.setItem('apollo-token', '');
                this.$router.push('/login');
            });
        }
    }
};
</script>

<style scoped>

    .v-list{
        padding: 12px 0 0 0;
    }
    .v-application .title {
        font-size: 1.3rem !important;
    }
    .v-list-item--disabled{
        opacity: 0.6;
    }
</style>
